import { render } from "./Paginacion.vue?vue&type=template&id=9db83d72&scoped=true"
import script from "./Paginacion.vue?vue&type=script&lang=js"
export * from "./Paginacion.vue?vue&type=script&lang=js"

import "./Paginacion.vue?vue&type=style&index=0&id=9db83d72&scoped=true&lang=scss"

import exportComponent from "/Users/dracoghost/Documents/ProyectosFunkoPopMorelia/funkopopmorelia-catalogo-vue-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db83d72"]])

export default __exports__